<div class="ui segment">
    <app-segment-header title="applicant-tracker.jobBoardIntegrationsTitle"></app-segment-header>
    <div *ngIf="(jobPosting.isPaused && integration) || jobPosting.isArchived">
        <app-empty-state
            label="applicant-tracker.emptyStateJobPosting"
            src="/assets/illustrations/briefcase.png"
        ></app-empty-state>
    </div>
    <div *ngIf="!integration?.isEnabled" class="flex col align-items-center justify-center">
        <p class="text-align-center" [innerHTML]="'applicant-tracker.integrationsNotConnected' | appTranslate"></p>
        <ui-button type="primary" (click)="onConnectIntegration()">{{
            'applicant-tracker.connectIntegration' | appTranslate
        }}</ui-button>
    </div>
    <div *ngIf="integration?.isEnabled && !jobPosting.isPaused && !jobPosting.isArchived">
        <!--    Header-->
        <div class="app-grid integration-header">
            <div class="columns-4"></div>
            <div class="columns-8 text-align-center">{{ 'applicant-tracker.postingLink' | appTranslate }}</div>
        </div>
        <!--    Body-->
        <div class="app-grid integration-item">
            <div class="columns-4">
                <div class="flex align-items-center">
                    <mat-slide-toggle
                        name="indeedToggle"
                        color="primary"
                        [ngModel]="jobIntegration?.isEnabled"
                        (ngModelChange)="integrationChange.emit($event)"
                        [disabled]="isSyncing"
                    >
                        <div class="flex align-items-center">
                            <img src="assets/logos/indeed.png" alt="indeed-logo" class="indeed-logo" />
                        </div>
                    </mat-slide-toggle>
                    <ui-badge class="margin-left-3" *ngIf="isSyncing && !isFailed">{{
                        'applicant-tracker.syncingPill' | appTranslate
                    }}</ui-badge>
                    <ui-badge type="danger" class="margin-left-3" *ngIf="isFailed">{{
                        'applicant-tracker.failedPill' | appTranslate
                    }}</ui-badge>
                </div>
            </div>
            <div class="columns-8 text-align-center">
                <ui-button type="link" [disabled]="!indeedPublicUrl" (click)="onOpenLink()"
                    ><mat-icon svgIcon="openInNew"></mat-icon> {{ 'applicant-tracker.openLink' | appTranslate }}
                </ui-button>
            </div>
        </div>
    </div>
</div>
